import { render } from "./relojesmusica.vue?vue&type=template&id=31edd3f6"
import script from "./relojesmusica.vue?vue&type=script&lang=js"
export * from "./relojesmusica.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__